/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Header_Technicaldetails1Inputs */

const id_builds_header_technicaldetails1 = /** @type {(inputs: Builds_Header_Technicaldetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detail teknis`)
};

const ms_builds_header_technicaldetails1 = /** @type {(inputs: Builds_Header_Technicaldetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Butiran teknikal`)
};

const da_builds_header_technicaldetails1 = /** @type {(inputs: Builds_Header_Technicaldetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekniske detaljer`)
};

const de_builds_header_technicaldetails1 = /** @type {(inputs: Builds_Header_Technicaldetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technische Details`)
};

const en_us2_builds_header_technicaldetails1 = /** @type {(inputs: Builds_Header_Technicaldetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technical details`)
};

const es_es2_builds_header_technicaldetails1 = /** @type {(inputs: Builds_Header_Technicaldetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalles técnicos`)
};

const es_mx2_builds_header_technicaldetails1 = /** @type {(inputs: Builds_Header_Technicaldetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalles técnicos`)
};

const fil_builds_header_technicaldetails1 = /** @type {(inputs: Builds_Header_Technicaldetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teknikal na detalye`)
};

const fr_builds_header_technicaldetails1 = /** @type {(inputs: Builds_Header_Technicaldetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détails techniques`)
};

const it_builds_header_technicaldetails1 = /** @type {(inputs: Builds_Header_Technicaldetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dettagli tecnici`)
};

const hu_builds_header_technicaldetails1 = /** @type {(inputs: Builds_Header_Technicaldetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technikai részletek`)
};

const nl_builds_header_technicaldetails1 = /** @type {(inputs: Builds_Header_Technicaldetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technische details`)
};

const no_builds_header_technicaldetails1 = /** @type {(inputs: Builds_Header_Technicaldetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekniske detaljer`)
};

const pl_builds_header_technicaldetails1 = /** @type {(inputs: Builds_Header_Technicaldetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szczegóły techniczne`)
};

const pt_br2_builds_header_technicaldetails1 = /** @type {(inputs: Builds_Header_Technicaldetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalhes técnicos`)
};

const pt_builds_header_technicaldetails1 = /** @type {(inputs: Builds_Header_Technicaldetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalhes técnicos`)
};

const ro_builds_header_technicaldetails1 = /** @type {(inputs: Builds_Header_Technicaldetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalii tehnice`)
};

const fi_builds_header_technicaldetails1 = /** @type {(inputs: Builds_Header_Technicaldetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekniset tiedot`)
};

const sv_builds_header_technicaldetails1 = /** @type {(inputs: Builds_Header_Technicaldetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekniska detaljer`)
};

const vi_builds_header_technicaldetails1 = /** @type {(inputs: Builds_Header_Technicaldetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chi tiết kỹ thuật`)
};

const tr_builds_header_technicaldetails1 = /** @type {(inputs: Builds_Header_Technicaldetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teknik ayrıntılar`)
};

const cs_builds_header_technicaldetails1 = /** @type {(inputs: Builds_Header_Technicaldetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technické podrobnosti`)
};

const bg_builds_header_technicaldetails1 = /** @type {(inputs: Builds_Header_Technicaldetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Технически подробности`)
};

const ru_builds_header_technicaldetails1 = /** @type {(inputs: Builds_Header_Technicaldetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Технические сведения`)
};

const uk_builds_header_technicaldetails1 = /** @type {(inputs: Builds_Header_Technicaldetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Технічні відомості`)
};

const ar_builds_header_technicaldetails1 = /** @type {(inputs: Builds_Header_Technicaldetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التفاصيل التقنية`)
};

const hi_builds_header_technicaldetails1 = /** @type {(inputs: Builds_Header_Technicaldetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तकनीकी विवरण`)
};

const th_builds_header_technicaldetails1 = /** @type {(inputs: Builds_Header_Technicaldetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายละเอียดทางเทคนิค`)
};

const ja_builds_header_technicaldetails1 = /** @type {(inputs: Builds_Header_Technicaldetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`技術詳細`)
};

const zh_cn2_builds_header_technicaldetails1 = /** @type {(inputs: Builds_Header_Technicaldetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`技术详情`)
};

const zh_hant1_builds_header_technicaldetails1 = /** @type {(inputs: Builds_Header_Technicaldetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`技術詳細資料`)
};

const ko_builds_header_technicaldetails1 = /** @type {(inputs: Builds_Header_Technicaldetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기술 세부 정보`)
};

/**
* | output |
* | --- |
* | "Technical details" |
*
* @param {Builds_Header_Technicaldetails1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_header_technicaldetails1 = /** @type {((inputs?: Builds_Header_Technicaldetails1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Header_Technicaldetails1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_header_technicaldetails1(inputs)
	if (locale === "ms") return ms_builds_header_technicaldetails1(inputs)
	if (locale === "da") return da_builds_header_technicaldetails1(inputs)
	if (locale === "de") return de_builds_header_technicaldetails1(inputs)
	if (locale === "en-US") return en_us2_builds_header_technicaldetails1(inputs)
	if (locale === "es-ES") return es_es2_builds_header_technicaldetails1(inputs)
	if (locale === "es-MX") return es_mx2_builds_header_technicaldetails1(inputs)
	if (locale === "fil") return fil_builds_header_technicaldetails1(inputs)
	if (locale === "fr") return fr_builds_header_technicaldetails1(inputs)
	if (locale === "it") return it_builds_header_technicaldetails1(inputs)
	if (locale === "hu") return hu_builds_header_technicaldetails1(inputs)
	if (locale === "nl") return nl_builds_header_technicaldetails1(inputs)
	if (locale === "no") return no_builds_header_technicaldetails1(inputs)
	if (locale === "pl") return pl_builds_header_technicaldetails1(inputs)
	if (locale === "pt-BR") return pt_br2_builds_header_technicaldetails1(inputs)
	if (locale === "pt") return pt_builds_header_technicaldetails1(inputs)
	if (locale === "ro") return ro_builds_header_technicaldetails1(inputs)
	if (locale === "fi") return fi_builds_header_technicaldetails1(inputs)
	if (locale === "sv") return sv_builds_header_technicaldetails1(inputs)
	if (locale === "vi") return vi_builds_header_technicaldetails1(inputs)
	if (locale === "tr") return tr_builds_header_technicaldetails1(inputs)
	if (locale === "cs") return cs_builds_header_technicaldetails1(inputs)
	if (locale === "bg") return bg_builds_header_technicaldetails1(inputs)
	if (locale === "ru") return ru_builds_header_technicaldetails1(inputs)
	if (locale === "uk") return uk_builds_header_technicaldetails1(inputs)
	if (locale === "ar") return ar_builds_header_technicaldetails1(inputs)
	if (locale === "hi") return hi_builds_header_technicaldetails1(inputs)
	if (locale === "th") return th_builds_header_technicaldetails1(inputs)
	if (locale === "ja") return ja_builds_header_technicaldetails1(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_header_technicaldetails1(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_header_technicaldetails1(inputs)
	return ko_builds_header_technicaldetails1(inputs)
});
export { builds_header_technicaldetails1 as "builds.header.technicalDetails" }